import Vue from 'vue';
import Router from 'vue-router';
import { Toast } from 'vant';

import Home from './pages/Home';
import Orders from './pages/Orders';
import Order from './pages/Order';
import Buy from './pages/Buy';
import ApplyAlter from './pages/ApplyAlter';
import Product from './pages/Product';
import Evaluation from './pages/Evaluation';
import Coupons from './pages/Coupons';
import WorkSelector from './pages/WorkSelector';
import WorkUploader from './pages/WorkUploader';
import GotoPayment from './pages/GotoPayment';
import PageNotFound from './pages/404';

import StudioProduct from './studio/pages/Product';
import StudioBuy from './studio/pages/Buy';
import StudioOrder from './studio/pages/Order';
import StudioWorkUploader from './studio/pages/WorkUploader';
import StudioEvaluation from './studio/pages/Evaluation';

// 解决唱吧 APP 内，安卓不支持前进后退的问题
import '@module/helper/changba-caller'

// 拦截编程式导航，自动添加 curuserid 和 token 参数
import '@module/helper/router-push-replace'

Vue.use(Router)

const router = new Router({
  base: '/njwap/chanpin/mall/index/main',
  mode: 'history',
  //scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/orders/(post)?',
      component: Orders,
      props: { tab: 'post' },
      meta: { title: '订单列表' }
    },
    {
      path: '/orders/market',
      component: Orders,
      props: { tab: 'market' },
      meta: { title: '订单列表' }
    },
    {
      path: '/orders/studio',
      component: Orders,
      props: { tab: 'studio' },
      meta: { title: '订单列表' }
    },
    {
      path: '/buy',
      component: Buy,
      meta: {
        title: '订单确认',
        keepAlive: false
      }
    },
    {
      path: '/order/:id',
      component: Order,
      props: true,
      meta: {
        title: '订单详情',
        keepAlive: false
      }
    },
    {
      path: '/apply-alter/:id',
      component: ApplyAlter,
      props: true,
      meta: {
        title: '申请修改',
        keepAlive: false
      }
    },
    {
      path: '/product/:id',
      component: Product,
      props: true,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/evaluation/:id',
      component: Evaluation,
      props: true,
      meta: {
        title: '评价',
        keepAlive: false
      }
    },
    {
      path: '/coupons',
      component: Coupons,
      meta: { title: '优惠券' }
    },
    {
      path: '/work-selector/:id',
      component: WorkSelector,
      props: true,
      meta: {
        title: '上传作品',
        keepAlive: false
      }
    },
    {
      path: '/work-uploader',
      component: WorkUploader,
      meta: {
        title: '上传作品',
        keepAlive: false
      }
    },
    {
      path: '/goto-payment/:id',
      component: GotoPayment,
      props: true,
      meta: {
        title: '正在跳转...',
        keepAlive: false
      }
    },
    {
      path: '/intro',
      component: () => import('./pages/Intro'),
      meta: {
        title: '了解详情'
      }
    },

    // 音乐工作室
    {
      path: '/studio/product/:id',
      component: StudioProduct,
      props: true,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/studio/buy/:id',
      component: StudioBuy,
      props: true,
      meta: {
        title: '订单确认',
        keepAlive: false
      }
    },
    {
      path: '/studio/order/:id',
      component: StudioOrder,
      props: true,
      meta: {
        title: '订单详情',
        keepAlive: false
      }
    },
    {
      path: '/studio/work-uploader/:id',
      component: StudioWorkUploader,
      props: true,
      meta: {
        title: '上传作品',
        keepAlive: false
      }
    },
    {
      path: '/studio/evaluation/:id',
      component: StudioEvaluation,
      props: true,
      meta: {
        title: '评价',
        keepAlive: false
      }
    },

    // 音乐教学
    {
      path: '/homes/education',
      component: () => import('./homes/Education'),
      meta: { title: '音乐教学' }
    },

    // 人工修音
    {
      path: '/homes/post-production',
      component: () => import('./homes/PostProduction'),
      meta: { title: '人工修音' }
    },
    {
      path: '/homes/welfare',
      component: () => import('./homes/Welfare'),
      meta: { title: '人工修音' }
    },

    // 全网发行
    {
      path: '/homes/mercury',
      component: () => import('./homes/Mercury'),
      meta: { title: '全网发行', className: 'homes-mercury', keepAlive: false }
    },

    {
      path: '/404',
      component: PageNotFound,
      meta: {
        title: '404 页面未找到'
      }
    },
    {
      path: '*',
      component: PageNotFound,
      meta: {
        title: '404 页面未找到'
      }
    }
  ]
});

let loadingTimer;

router.beforeEach((to, from, next) => {
  try {
    // 删除所有全局 css class
    document.querySelector('html').classList.forEach((item, index, obj) => {
      if (item.indexOf('page-') === 0) {
        obj.remove(item);
      }
    });
  }
  catch (e) {
  }

  loadingTimer = setTimeout(() => {
    Toast.loading({
      duration: 0,
      forbidClick: true
    });
  }, 100);

  if (to.path.indexOf('&') > 0) {
    next({
      path: to.path.replace('&', '?'),
      replace: true
    });
  }
  else {
    next();
  }
});

router.afterEach((to) => {
  clearTimeout(loadingTimer);
  Toast.clear();

  try {
    // 设置一个全局 css class
    const className = to.meta.className;
    if (className) {
      document.querySelector('html').classList.add(`page-${className}`);
    }
  }
  catch (e) {
  }

  // 自动设置全局背景色
  Vue.nextTick(() => {
    setTimeout(() => {
      try {
        const backgroundColor = window.getComputedStyle(router.app.$el.querySelector(':first-child')).getPropertyValue('background-color');
        document.querySelector('html').style.backgroundColor = backgroundColor;
        document.querySelector('body').style.backgroundColor = backgroundColor;
      }
      catch (e) {
      }
    }, 0);
  });

  document.title = to.meta?.title ?? '人工修音';

  if (window._cbs) {
    let pageId = document.title;
    let page = '(none)';

    if (to.matched[0]) {
      page = to.matched[0].components.default.name
      pageId += `(${page})`;
    }

    window._cbs.setDefault('pageId', pageId);

    window._cbs.pv();
    window._cbs.action(`cbs_page_${page}`, { urlParams: to.path });
  }
});

export default router;
